// extracted by mini-css-extract-plugin
export var backCloudsContainer = "Background-module--backCloudsContainer--e8dab";
export var background = "Background-module--background--c76b1";
export var container = "Background-module--container--acdcf";
export var frontCloud = "Background-module--frontCloud--a4eaf";
export var frontCloudContainer = "Background-module--frontCloudContainer--cb70d";
export var frontCloudsContainer = "Background-module--frontCloudsContainer--8d62b";
export var middleRightCloud = "Background-module--middleRightCloud--1fff7";
export var middleRightCloudContainer = "Background-module--middleRightCloudContainer--804f1";
export var middleRightCloudElementsContainer = "Background-module--middleRightCloudElementsContainer--7ad9d";
export var moon = "Background-module--moon--f9f54";
export var stars = "Background-module--stars--d3e30";
export var sun = "Background-module--sun--3d31b";
export var sunAura = "Background-module--sunAura--acc50";
export var topLeftCloud = "Background-module--topLeftCloud--15209";
export var topLeftCloudContainer = "Background-module--topLeftCloudContainer--2690d";
export var topRightCloud = "Background-module--topRightCloud--cad45";
export var topRightCloudContainer = "Background-module--topRightCloudContainer--3f91d";
export var topRightCloudElementsContainer = "Background-module--topRightCloudElementsContainer--bbfcd";